export const NAVBAR_COLLAPSED_WIDTH = '64px'
export const NAVBAR_WIDTH = '260px'
export const EMBER_SIDEBAR_WIDTH = '400px'
export const EMBER_SIDEBAR_EXPANDED_WIDTH = '50%'
export const DASHBOARD_CARD_PADDING = '18px'
export const HEADER_BAR_HEIGHT = '70px'
export const HEADER_BAR_MARGIN_BOTTOM = '4px'
export const CENTER_CONTENT_PADDING_BOTTOM = '10px'
export const ALL_BUILDINGS_ID = 'allBuildings'
export const ALL_ENERGY_TYPES_ID = 'allEnergyTypes'
import { t } from 'i18next'

export const ALL_REGIONS_LABEL = t('common.group')
export const ALL_LOCATIONS_LABEL = t('common.all_locations')
export const ALL_BUILDINGS_LABEL = t('common.all_buildings')
export const ALL_ENERGY_TYPES_LABEL = t('common.all_types')

export const TABS = {
  efficiencyAndMeasures: {
    overview: 'overview',
    team: 'energy-team',
    organizationContext: 'organization-context',
    energyGoals: 'energy-goals',
    measures: 'measures',
    documentation: 'documentation',
    valeri: 'valeri',
  },
  measureHub: {
    simulation: 'simulation',
    measures: 'measures',
    valeri: 'valeri',
    analyticsBaseline: 'baseline-analysis',
    enpi: 'enpi',
  },
  energiekosten: {
    trend: 'costs-trend',
    audit: 'invoice-audits',
  },
  datenmanagement: {
    timeSeries: 'time-series',
    document: 'document',
    export: 'export',
    manualMeters: 'manual-meters',
  },
  procurementAndMarkets: {
    procurement: 'procurement',
    markets: 'markets',
  },
  procurement: {
    portfolio: 'portfolio',
    liveMarktfolge: 'live-marktfolge',
    vertragsdetails: 'vertragsdetails',
    mengenplanung: 'mengenplanung',
  },
  forecasting: {
    verbrauch: 'verbrauch',
    anpassungen: 'anpassungen',
  },
  portfolio: {
    table: 'table',
    diagram: 'diagram',
  },
  analysis: {
    batch: 'batch',
    visualization: 'visualization',
    regression: 'regression',
    comparison: 'comparison',
    baseline: 'baseline',
    energyInsights: 'energy-insights',
    standortvergleich: 'standortvergleich',
    lastgangdetails: 'lastgangdetails',
  },
  locations: {
    overview: 'overview',
    trend: 'trend',
  },
  messstellen: {
    overview: 'overview',
    shiftDiagram: 'shift-diagram',
    sankey: 'sankey',
    customViews: 'custom-views',
    energyEvaluation: 'energy-evaluation',
    // EC-5827: behind the easy-offer-enpi feature flag
    enpi: 'enpi',
  },
  flex: {
    sectorCoupling: 'sector-coupling',
    batteryControl: 'battery-control',
  },
  reports: {
    overview: 'reports',
  },
  // These tabs are from the pre base product era, but still needed to map ember redirections
  energyInsights: {
    consumptionTrends: 'consumption-trends',
    energyEfficiency: 'energy-efficiency',
    costsBudget: 'costs-budget',
    co2Emissions: 'co2-emissions',
    loadProfileDetails: 'load-profile-details',
  },
  insightInbox: {
    new: 'new',
    investigation: 'investigation',
    assignedToMe: 'assigned-to-me',
    convertedToMeasure: 'converted-to-measure',
    resolved: 'resolved',
    dismissed: 'dismissed',
    notReleased: 'not-released',
  },
  consultancy: {
    usersAndGroups: 'users-and-groups',
    users: 'users-and-groups/users',
    groups: 'users-and-groups/groups',
    dataManagement: 'data-management',
    locationAndDevices: 'data-management/locations-and-devices',
    dataGaps: 'data-management/data-gaps',
    costs: 'costs',
    energieeinkauf: 'energieeinkauf',
  },
} as const

export const CUSTOM_VIEWS_TABS = {
  table: 'table',
  sankey: 'sankey',
} as const

export const FULL_PERCENT = 100
export const ECOPLANET_DOMAIN = '@ecoplanet.tech'
export const ONE_SECOND_IN_MS = 1000
export const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * 60

export const MONTHS_OPTIONS = [
  { label: t('months.january'), value: 'january', short: t('months_short.january'), shortEng: 'Jan' },
  { label: t('months.february'), value: 'february', short: t('months_short.february'), shortEng: 'Feb' },
  { label: t('months.march'), value: 'march', short: t('months_short.march'), shortEng: 'Mar' },
  { label: t('months.april'), value: 'april', short: t('months_short.april'), shortEng: 'Apr' },
  { label: t('months.may'), value: 'may', short: t('months_short.may'), shortEng: 'May' },
  { label: t('months.june'), value: 'june', short: t('months_short.june'), shortEng: 'Jun' },
  { label: t('months.july'), value: 'july', short: t('months_short.july'), shortEng: 'Jul' },
  { label: t('months.august'), value: 'august', short: t('months_short.august'), shortEng: 'Aug' },
  { label: t('months.september'), value: 'september', short: t('months_short.september'), shortEng: 'Sep' },
  { label: t('months.october'), value: 'october', short: t('months_short.october'), shortEng: 'Oct' },
  { label: t('months.november'), value: 'november', short: t('months_short.november'), shortEng: 'Nov' },
  { label: t('months.december'), value: 'december', short: t('months_short.december'), shortEng: 'Dec' },
]

export const INDUSTRIES = {
  MANUFACTURING_INDUSTRY: 'Produzierendes Gewerbe',
  FOOD_PRODUCTION: 'Lebensmittelindustrie',
  TRANSPORTATION_AND_STORAGE: 'Logistik',
  HOSPITALITY: 'Gesundheits- und Sozialwesen ',
  CONSTRUCTION: 'Baugewerbe',
  FOOD_TRADE: 'Lebensmittelhandel',
  GENERAL_TRADE: 'Handel',
  MINING: 'Bergbau',
  REAL_ESTATE_AND_HOUSING: 'Immobilienwirtschaft',
} as const

export const TIME_OPTIONS = [
  { label: '00:00', value: '00:00' },
  { label: '00:30', value: '00:30' },
  { label: '1:00', value: '01:00' },
  { label: '1:30', value: '01:30' },
  { label: '2:00', value: '02:00' },
  { label: '2:30', value: '02:30' },
  { label: '3:00', value: '03:00' },
  { label: '3:30', value: '03:30' },
  { label: '4:00', value: '04:00' },
  { label: '4:30', value: '04:30' },
  { label: '5:00', value: '05:00' },
  { label: '5:30', value: '05:30' },
  { label: '6:00', value: '06:00' },
  { label: '6:30', value: '06:30' },
  { label: '7:00', value: '07:00' },
  { label: '7:30', value: '07:30' },
  { label: '8:00', value: '08:00' },
  { label: '8:30', value: '08:30' },
  { label: '9:00', value: '09:00' },
  { label: '9:30', value: '09:30' },
  { label: '10:00', value: '10:00' },
  { label: '10:30', value: '10:30' },
  { label: '11:00', value: '11:00' },
  { label: '11:30', value: '11:30' },
  { label: '12:00', value: '12:00' },
  { label: '12:30', value: '12:30' },
  { label: '13:00', value: '13:00' },
  { label: '13:00', value: '13:00' },
  { label: '13:30', value: '13:30' },
  { label: '14:00', value: '14:00' },
  { label: '14:30', value: '14:30' },
  { label: '15:00', value: '15:00' },
  { label: '15:30', value: '15:30' },
  { label: '16:00', value: '16:00' },
  { label: '16:30', value: '16:30' },
  { label: '17:00', value: '17:00' },
  { label: '17:30', value: '17:30' },
  { label: '18:00', value: '18:00' },
  { label: '18:30', value: '18:30' },
  { label: '19:00', value: '19:00' },
  { label: '19:30', value: '19:30' },
  { label: '20:00', value: '20:00' },
  { label: '20:30', value: '20:30' },
  { label: '21:00', value: '21:00' },
  { label: '21:30', value: '21:30' },
  { label: '22:00', value: '22:00' },
  { label: '22:30', value: '22:30' },
  { label: '23:00', value: '23:00' },
  { label: '23:30', value: '23:30' },
] as const

export const WEEK_DAYS_OPTIONS = [
  { value: 'monday', label: 'M' },
  { value: 'tuesday', label: 'D' },
  { value: 'wednesday', label: 'M' },
  { value: 'thursday', label: 'D' },
  { value: 'friday', label: 'F' },
  { value: 'saturday', label: 'S' },
  { value: 'sunday', label: 'S' },
] as const

// base routes consts
export const EFFICIENCY_AND_MEASURES_BASE_ROUTE = '/efficiency-and-measures'
export const ENERGY_COST_BASE_ROUTE = '/energy-cost'
export const PROCUREMENT_AND_MARKETS_BASE_ROUTE = '/procurement-and-markets'
export const DATA_MANAGEMENT_BASE_ROUTE = '/data-management'
export const ANALYSES_BASE_ROUTE = '/analyses'
export const MESSSTELLEN_BASE_ROUTE = '/messstellen'
export const AWARENESS_BASE_ROUTE = '/awareness'
export const FLEX_BASE_ROUTE = '/flex'
export const REPORTS_BASE_ROUTE = '/reporting'
export const CUSTOM_SECTION_BASE_ROUTE = '/custom-section'
export const MEASURES_BASE_ROUTE = '/measures'
export const INSIGHT_INBOX_BASE_ROUTE = '/insight-inbox'

// consultancy route
export const CONSULTANCY_BASE_ROUTE = '/consultancy'

export const INSIGHTS_BASE_ROUTE = '/insights'

export const INSIGHTS_SETTINGS_ROUTE = `${INSIGHTS_BASE_ROUTE}/settings`

export const INSIGHTS_RECOMMENDATIONS_ROUTE = `${INSIGHTS_SETTINGS_ROUTE}/recommendations`

export const CUBIC_METERS_ENERGY_TYPES = ['fluidGas', 'water', 'pressurizedAir']

export const measurementUnitIdsMap = {
  2: 'kWh',
  3: 'm3',
}

export const PROCUREMENT_STRATEGY_TYPES = {
  STATIC: 'static',
  HEDGED: 'hedged',
  PLANNED: 'planned',
}

export const CLEAR_OPTION_VALUE = '__CLEAR__'

// A "single-location account"
export const SINGLE_LOCATION_OPTIONS_COUNT = 2
